/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomComponentIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomComponentIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentIdQueryOperator>): AppSecopsSbomComponentIdQueryOperator {
        let obj = Object.assign(new AppSecopsSbomComponentIdQueryOperator(), model);
        AppSecopsSbomComponentIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentIdQueryOperator>): AppSecopsSbomComponentIdQueryOperator {
        if (!model) return null;
        return AppSecopsSbomComponentIdQueryOperator.newInstance(<AppSecopsSbomComponentIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomComponentIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomComponentIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM component IDs to include
     */
    component_ids: Array<string>;

}
